import React from 'react';
import { Label } from '../../api/queries';
import classes from './PillLabel.module.css';
import { Paragraph } from '../Paragraph';
import { ColorUtils } from '../../utils/ColorUtils/ColorUtils';

type PillLabelProps = {
  label: Label;
};

export const PillLabel = ({ label }: PillLabelProps) => {
  const textColorBasedOnLabelColor = ColorUtils.getContrastTextColor(
    label.color,
  );
  return (
    <div className={classes.pillLabel} style={{ backgroundColor: label.color }}>
      <Paragraph size="md" style={{ color: textColorBasedOnLabelColor }}>
        {label.name}
      </Paragraph>
    </div>
  );
};
